import { useToast } from '@chakra-ui/react';
import { useRef } from 'react';
import { EmailType } from '@acp/shared';
import { SendEmailModalRef } from '../../../components/forms';
import { SendEmailModal } from '../../../components/modals';
import { useQuoteForward } from './use-quote-forward';
import { ForwardEmailFormValues } from '../../email';

export function ForwardQuoteModal({
    isOpen,
    onClose,
    propertyId,
    quoteId,
}: {
    isOpen: boolean;
    onClose: (hasSent: boolean) => void;
    propertyId: number;
    quoteId: number;
}) {
    const formRef = useRef<SendEmailModalRef>(null);

    const toast = useToast();

    const forwardQuoteMutation = useQuoteForward({
        onSuccess: () => {
            toast({
                title: 'Quote email forwarded',
                description: 'The specified recipient(s) should receive the email shortly.',
                status: 'success',
                isClosable: true,
            });

            formRef.current?.resetForm();
            onClose(true);
        },
    });

    const handleClose = () => {
        forwardQuoteMutation.reset();
        onClose(false);
    };

    const onSubmit = (vals: ForwardEmailFormValues) => {
        forwardQuoteMutation.mutate({
            quoteId,
            toAddresses: vals.toEmails.map((email) => email.value),
            ccAddresses: vals.ccEmails.map((email) => email.value),
            message: vals.emailMessage,
            subscribeToNotifications: vals.sendToDefaultRecipient,
        });
    };

    return (
        <SendEmailModal
            ref={formRef}
            title="Forward quote"
            propertyId={propertyId}
            mutation={forwardQuoteMutation}
            onClose={handleClose}
            onSubmit={onSubmit}
            isOpen={isOpen}
            extraErrorMessage="We were unable to forward this quote"
            includeLandlords
            includePropertyManagers
            allowSubscribe
            previewAvailable
            metaData={{
                emailType: EmailType.FORWARD_QUOTATION,
                propertyId,
                quoteId,
            }}
        />
    );
}
